import { render, staticRenderFns } from "./DeleteUserModal.vue?vue&type=template&id=44801903&scoped=true&"
import script from "./DeleteUserModal.vue?vue&type=script&lang=js&"
export * from "./DeleteUserModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteUserModal.vue?vue&type=style&index=0&id=44801903&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44801903",
  null
  
)

export default component.exports